import { debounce, smoothScrollTo } from "@theme/utilities";

function init() {
  const el = document.getElementById("eza-in-page-product-nav");
  if (!el) return;

  const cloneEl = el.cloneNode(true);
  cloneEl.id = `${cloneEl.id}-clone`;
  cloneEl.classList.add("clone");

  const yokedEls = [el, cloneEl];
  function addYokedElClass(...classes) {
    yokedEls.forEach((yokedEl) => {
      yokedEl.classList.add(...classes);
    });
  }
  function removeYokedElClass(...classes) {
    yokedEls.forEach((yokedEl) => {
      yokedEl.classList.remove(...classes);
    });
  }

  const stickyParentEl = document.getElementById("header-group");
  if (!stickyParentEl) return;

  stickyParentEl.append(cloneEl);

  const titleEl = el.querySelector(".eza-info .eza-title");
  if (titleEl) {
    function setTitleIsOverflowing() {
      if (!titleEl) return;

      const afterStyle = window.getComputedStyle(titleEl, "::after");
      const afterWidth = parseFloat(afterStyle.width) || 0;

      const isOverflowing =
        titleEl.offsetWidth < titleEl?.scrollWidth - afterWidth;

      titleEl.classList[isOverflowing ? "add" : "remove"]("is-overflowing");
    }
    setTitleIsOverflowing();

    const debouncedSetTitleIsOverflowing = debounce(setTitleIsOverflowing, 500);
    const titleResizeObserver = new ResizeObserver(
      debouncedSetTitleIsOverflowing,
    );
    titleResizeObserver.observe(titleEl);
  }

  let hasButton = false;

  const offsetElements = [
    document.querySelector(
      "#header-group:has(#header-component[sticky=always])",
    ),
  ].filter(Boolean);

  function getOffset() {
    return offsetElements.reduce((offset, offsetEl) => {
      return offset + (offsetEl?.offsetHeight || 0);
    }, 0);
  }
  const offset = getOffset();
  console.log(offset);

  let elScrollTop = 0;
  const elIntersectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const currentScrollTop = entry.boundingClientRect.top;
        const hasExited =
          !entry.isIntersecting && currentScrollTop < elScrollTop;
        if (hasExited) {
          addYokedElClass("show", "scrolled");
          setTimeout(() => {
            addYokedElClass("condensed");
          }, 1);
        } else removeYokedElClass("show", "condensed", "scrolled");
        elScrollTop = currentScrollTop;
      });
    },
    {
      // @TODO this probably needs the offset as root margins
      rootMargin: `-${offset}px 0px 0px 0px`,
      threshold: 1,
    },
  );
  elIntersectionObserver.observe(el);

  const addToCartButton = document.querySelector(
    "subscription-selector, .vpv-sub-selector, [ref='addToCartButton'], button[name='add'], .product-form__submit",
  );
  if (!addToCartButton) return;

  let lastAddToCartScrollTop = 0;
  const addToCartButtonObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const currentScrollTop = entry.boundingClientRect.top;
        hasButton =
          !entry.isIntersecting && currentScrollTop < lastAddToCartScrollTop;
        cloneEl.classList[hasButton ? "add" : "remove"]("has-button");
        lastAddToCartScrollTop = currentScrollTop;
      });
    },
    {
      threshold: [0, 0.25, 0.5, 0.75, 1],
      rootMargin: `${offset * -1}px 0px 0px 0px`,
    },
  );
  addToCartButtonObserver.observe(addToCartButton);

  const shopNowButton = cloneEl.querySelector(".eza-actions .eza-button");
  if (!shopNowButton) return;

  const SCROLL_DURATION = 1000;

  shopNowButton.addEventListener("click", () => {
    const scrollTargetEl = document.querySelector(
      ".eza-variant-picker, .recharge-block, vpv-sub-selector",
    );
    if (!scrollTargetEl) return;

    const top =
      scrollTargetEl.getBoundingClientRect().top +
      window.scrollY -
      getOffset() -
      el.offsetHeight;
    smoothScrollTo(top, SCROLL_DURATION);
  });
}
init();
